import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, ActivatedRoute, Params } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { PageEvent, MatPaginatorModule } from '@angular/material/paginator';

import { CommonModule } from '@angular/common';

import { BookmarksService } from './bookmarks.service';

@Component({
  selector: 'app-bookmarks',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    RouterLink,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    CommonModule,
    MatPaginatorModule
  ],
  templateUrl: './bookmarks.component.html',
  styleUrl: './bookmarks.component.css'
})
export class BookmarksComponent implements OnInit {
  items: any[] = [];
  api_key = "";
  timeout: any = null;
  length = 50;
  pageSize = 25;
  pageIndex = 0;
  pageSizeOptions = [25, 100, 1000];
  searchTerm = ""

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private bookmarksService: BookmarksService
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem('api_key') === null || localStorage.getItem('api_key') === '') {
      this.router.navigate(['/404']);
      return;
    }
    this.api_key = localStorage.getItem('api_key')!;
    this.populateBookmarks();
    this.getBookmarksLength();
  }


  onKeySearch(event: any) {
    clearTimeout(this.timeout);
    this.searchTerm = event.target.value;
    var $this = this;
    this.timeout = setTimeout(function () {
      $this.handlePageEvent(event);
      $this.executeSearch(event.target.value);
    }, 1000);
  }

  executeSearch(value: string) {
    this.searchTerm = value;
    this.populateBookmarks();
  }

  async populateBookmarks() {
    const response = await this.bookmarksService.getBookmarks(this.api_key, this.pageSize, this.pageIndex, this.searchTerm);
    const data = await response.json();
    console.log(data);
    if (data.success) {
      this.items = data.bookmarks;
    }
  }

  async getBookmarksLength() {
    const response = await this.bookmarksService.getBookmarksLength(this.api_key, this.searchTerm);
    const data = await response.json();
    console.log(data);
    if (data.success) {
      this.length = data.length;
    }
  }
  deleteBookmark(url: string) {
    this.bookmarksService.deleteBookmarkApi(this.api_key, url);
    let itemId = -1;
    let i = 0;
    for (const item of this.items) {
      if (item.url === url) {
        itemId = i;
        break;
      }
      i++;
    }
    if (itemId > -1) {
      this.items.splice(itemId, 1);
    }
  }

  pageEvent: PageEvent;

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    console.log(this.pageEvent);
    console.log(this.length);
    console.log(this.pageSize);
    console.log(this.pageIndex);
    this.getBookmarksLength();
    this.populateBookmarks();
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }
  }

}
